import { createDevice } from 'modules/devices/store/actions';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store/hooks';

export function useCreateDevice(tournamentId: number | null, refetch: () => void) {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (params: { name: string }) => {
      if (!tournamentId) return;
      setIsLoading(true);
      try {
        await dispatch(createDevice({ name: params.name, tournament_id: tournamentId })).unwrap();
        toast.success(t`Устройство создано`);
        refetch();
      } catch {
        toast.error(t`Не удалось создать устройство`);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, tournamentId, refetch, t],
  );

  return { mutate, isLoading };
}
